const { findKey, isEmpty } = require('lodash');

class CheckoutConfirmationOrderDetailsController {
    constructor(settings, shopperService) {
        this.settings = settings;
        this.shopperService = shopperService;
    }

    $onChanges(changes) {
        if (changes.order && changes.order.currentValue) {
            this.fulfilmentMethodName = this.getFulfilmentMethodName();
            this.paymentType = this.getPaymentType();
            this.packagingFeeEnabled = this.settings.checkout.enablePackagingPreference && !!this.order.PackagingFeeLabel;
        }
    }

    $onInit() {
        this.digitalPayFallbackEnabled = this.settings.digitalPay.digitalPayFallback;
        this.shopperService.getDeliveryPassesSummary().then((response) => {
            this.hasDeliveryPasses = response.ActiveDeliveryPassSummary
                || !isEmpty(response.UnusedDeliveryPassesSummary);
        });
    }

    getFulfilmentMethodName() {
        const isDelivery = this.order.DeliveryMethod === 'Courier' || this.order.DeliveryMethod === 'TPCour' || this.order.DeliveryMethod === 'XpressD';
        return isDelivery ? 'Delivery' : 'Pick up';
    }

    getPaymentType() {
        const paidByKey = findKey(this.order.PaymentBreakdown, payment => payment > 0);

        // Only support credit card, gift card and paypal for now
        switch (paidByKey) {
            case this.settings.orderConfirmation.creditCardKey:
                return 'Credit card';
            case this.settings.orderConfirmation.paypalKey:
                return 'PayPal';
            case this.settings.orderConfirmation.giftCardKey:
                return 'Gift card';
            default:
                return '';
        }
    }
}

CheckoutConfirmationOrderDetailsController.$inject = ['Settings', 'ShopperService'];

const checkoutConfirmationOrderDetailsControllerComponentDefinition = {
    bindings: {
        order: '<',
        orderCancelled: '<',
        showSaveCard: '<',
    },
    controller: CheckoutConfirmationOrderDetailsController,
    template: require('./checkout-confirmation-order-details.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationOrderDetailsController,
    checkoutConfirmationOrderDetailsControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkout-confirmation-order-details.component.js